module.exports = __webpack_public_path__ + "img/img_kb_type4_01.45496662.png";